<template>
  <div class="container mt-5">
    <!--     <div v-if="successMessage" class="alert alert-success text-center">
            {{ successMessage }}
          </div> -->
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <h1 class="float-left">Tax Calculation Form</h1>
        <form @submit.prevent="TaxCalculation" class="p-4 shadow-lg rounded bg-white">
          <div v-if="apierror" class="alert alert-danger d-flex align-items-center">
            <i class="fas fa-exclamation-triangle me-2"></i>
            <span>{{ apierror }}</span>
          </div>

          <div v-if="loader" class="text-center my-4 loader-overlay">
            <div class="fancy-loader"></div>
          </div>

          <h3 class="text-center text-dark mb-4">Enter Product Details</h3>
          <div class="mb-3">
            <label class="form-label">Product Name *</label>
            <input type="text" class="form-control" v-model="title" placeholder="Product Name"
              />
            <small v-if="errors.title" class="text-danger">{{ errors.title }}</small>
          </div>
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">Brand </label>
              <input
                type="text"
                class="form-control"
                placeholder="Brand"
                v-model="brand"
       
              />
               <small v-if="errors.brand" class="text-danger">{{
                errors.brand
              }}</small>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Quantity *</label>
              <input
                type="number"
                class="form-control"
                placeholder="Quantity"
                v-model="quantity"
              />
              <small v-if="errors.quantity" class="text-danger">{{
                errors.quantity
              }}</small>
            </div>

            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label">State *</label>
                <select v-model="state" class="form-control">
                  <option value="" disabled selected>Select a State</option>
                  <option
                    v-for="st in filteredStates"
                    :key="st.id"
                    :value="st.abbreviation"
                  >
                    {{ st.name }}
                  </option>
                </select>
                <small v-if="errors.state" class="text-danger">{{ errors.state }}</small>
              </div>

              <div class="col-md-6 mb-3">
                <label class="form-label">Category *</label>
                <select v-model="category" class="form-control">
                  <option value="" disabled>Select a Category</option>
                  <option v-for="cat in categories" :key="cat.id" :value="cat.name">
                    {{ cat.name }}
                  </option>
                </select>
                <small v-if="errors.category" class="text-danger">{{
                  errors.category
                }}</small>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label">Cost Price *</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="cost_price"
                  step="any"
                  placeholder="Cost Price"
                 @input="cost_price = cost_price.replace(/[^0-9.]/g, '')" 
                />
                <small v-if="errors.cost_price" class="text-danger">{{
                  errors.cost_price
                }}</small>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Sale Price *</label>
                <input
                  type="number"
                  step="0.01"
                  class="form-control"
                  v-model="sale_price"
                  placeholder="Sale Price"
                />
                <small v-if="errors.sale_price" class="text-danger">{{
                  errors.sale_price
                }}</small>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 mb-3">
              <label class="form-label">LSU Weight</label>
              <input
                type="number"
                class="form-control"
                v-model="lsu_weight"
                placeholder="LSU Weight"
                step="any"
              />
              <small v-if="errors.lsu_weight" class="text-danger">{{
                errors.lsu_weight
              }}</small>
            </div>
            <div class="col-md-4 mb-3">
              <label class="form-label">
                LSU Volume
                <i
                  class="bi bi-info-circle ms-1"
                  ref="lsuTooltip"
                  data-bs-toggle="tooltip"
                  title="LSU Volume is required for some states."
                  style="cursor: pointer"
                ></i>
              </label>
              <input
                type="number"
                class="form-control"
                placeholder="LSU Volume"
                v-model="lsu_volume"
                step="any"
              />
              <small v-if="errors.lsu_volume" class="text-danger">
                {{ errors.lsu_volume }}
              </small>
            </div>
            <div class="col-md-4 mb-3">
              <label class="form-label">
                LSU Factor
                <i
                  class="bi bi-info-circle ms-1"
                  ref="lsuFactorTooltip"
                  data-bs-toggle="tooltip"
                  title="LSU Factor is required for some states."
                  style="cursor: pointer"
                ></i>
              </label>
              <input
                type="number"
                class="form-control"
                placeholder="LSU Factor"
                v-model="lsu_factor"
                step="any"
              />
              <small v-if="errors.lsu_factor" class="text-danger">
                {{ errors.lsu_factor }}
              </small>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">Contains Nicotine</label>
              <select class="form-control" v-model="contains_nicotine">
                <option value="" disabled>Select</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Distributor *</label>
              <select class="form-control" v-model="distributor">
                <option value="" disabled>Select Distributor</option>
                    <option value="Yes">Yes</option>
                <option value="No">No</option>
            
              </select>
              <small v-if="errors.distributor" class="text-danger">{{
                errors.distributor
              }}</small>
            </div>
          </div>

          <button type="submit" class="btn btn-primary w-100">Calculate Tax</button>
        </form>
      </div>
    <div class="col-lg-6 col-md-12">
    <div
      v-if="result && Object.keys(result).length"
      class="result-box shadow-lg p-4 rounded bg-light"
      style="overflow-x: auto;"
    >
      <h3 class="text-center text-success mb-4">Tax Calculation Results</h3>

      <div class="row">
        <div class="col-md-6 mb-3">
          <h5>State</h5>
          <p class="result-value">{{ getStateName(result.state) }}</p>
        </div>
        <div class="col-md-6 mb-3">
          <h5>Category</h5>
          <p class="result-value">{{ result.category }}</p>
        </div>
        <div class="col-md-6 mb-3">
          <h5>Quantity</h5>
          <p class="result-value">{{ result.quantity }}</p>
        </div>
        <div class="col-md-6 mb-3">
          <h5>Sales Price</h5>
          <p class="result-value">${{ result.sale_price }}</p>
        </div>
        <div class="col-md-6 mb-3">
          <h5>Cost Price</h5>
          <p class="result-value">${{ result.cost_price }}</p>
        </div>
        <div class="col-md-6 mb-3">
          <h5>Total Price before tax</h5>
          <p class="result-value">${{ result.sale_price * result.quantity }}</p>
        </div>
        <div class="col-md-6 mb-3">
          <h5>Distributor Status</h5>
          <p class="result-value">{{ result.distributor }}</p>
        </div>
        <div class="col-md-6 mb-3">
          <h5>Calculated Tax</h5>
          <p class="result-value">${{ result.calculated_tax }}</p>
        </div>
        <div class="col-md-6 mb-3">
          <h5>Total Tax</h5>
          <p class="result-value">${{ result.total_tax }}</p>
        </div>
        <div class="col-md-6 mb-3">
          <h5>Total Price After Tax</h5>
          <p class="result-value">${{ result.total_price_after_tax }}</p>
        </div>
        <div class="col-md-6 mb-3">
          <h5>Taxable Status</h5>
          <p class="result-value">{{ result.taxable ? "Yes" : "No" }}</p>
        </div>
      </div>
    </div>
  </div>
    </div>
  </div>
</template>

<script>
import { AddTaxCalculation } from "../End Points/api";
import * as bootstrap from "bootstrap";
import { mapState } from "vuex";
export default {
  data() {
    return {
      state: "",
      category: "",
      quantity: null,
      sale_price: null,
      country: "USA",
      lsu_weight: 0,
      lsu_volume: 0,
      lsu_factor: 0,
      cost_price: null,
      brand: null,
      title: "",
      distributor: "",
      contains_nicotine: "",
      errors: {},
      successMessage: "",
      apierror: "",
      result: {},
      loader: false,
    };
  },
  computed: {
    ...mapState(["categories", "states"]),
    filteredStates() {
      return this.states.filter((st) => st.tax_applicable);
    },
    /*  filteredCategories() {
      return this.categories.filter((cat) => cat.is_active);
    }, */
  },

  mounted() {
    this.$store.dispatch("fetchCategories");
    this.$store.dispatch("fetchStates");

    const tooltipTrigger = this.$refs.lsuTooltip;
    if (tooltipTrigger) {
      new bootstrap.Tooltip(tooltipTrigger);
    }
    const lsuFactorEl = this.$refs.lsuFactorTooltip;
    if (lsuFactorEl) {
      new bootstrap.Tooltip(lsuFactorEl);
    }
  },
  methods: {
    getStateName(abbreviation) {
      const foundState = this.states.find((st) => st.abbreviation === abbreviation);
      return foundState ? foundState.name : "Unknown State";
    },
    validateForm() {
      this.errors = {};
      const salePrice = parseFloat(this.sale_price);
      const costPrice = parseFloat(this.cost_price);

      if (!this.state) this.errors.state = "State is required";
      if (!this.category) this.errors.category = "Category is required";
      if (!this.distributor) this.errors.distributor = "Distributor type is required";
       if (!this.quantity || this.quantity < 1 || this.quantity > 999999) 
         this.errors.quantity="Quantity must be between 1 and 999999"
      if (!this.title || this.title.trim() === "") {
        this.errors.title = "Product name is required";
      } else if (this.title.length > 255) {
        this.errors.title = "Product name must not exceed 255 characters";
      }
        if (this.brand && this.brand.trim() !== "") {
        if (this.brand.length > 255) {
      this.errors.brand = "Brand must not exceed 255 characters";
      }
     }
      if (this.lsu_weight === null || this.lsu_weight < 0 || this.lsu_weight > 999999) {
        this.errors.lsu_weight = "LSU Weight  must be between 0 and 999999";
      }
     if (this.lsu_volume === null || this.lsu_volume < 0 || this.lsu_volume > 999999) {
      this.errors.lsu_volume = "LSU Volume must be between 0 and 999999";
}

      if (this.lsu_factor === null || this.lsu_factor < 0 || this.lsu_factor>999999) {
        this.errors.lsu_factor = "LSU Factor must be between 0 and 999999";
      }
    if (!salePrice || salePrice <= 0 || this.sale_price > 999999) {
  this.errors.sale_price = "Sales Price must be between 1 and 999999";
}

if (!costPrice || costPrice <= 0 || this.cost_price > 999999) {
  this.errors.cost_price = "Cost Price must be between 1 and 999999";
}

if (salePrice && costPrice && salePrice < costPrice) {
  this.errors.sale_price = "Sales price must be greater than or equal to the cost price.";
}


  

      return Object.keys(this.errors).length === 0;
    },
    async TaxCalculation() {
      if (!this.validateForm()) {
        return;
      }
      this.loader = true;
      this.result = {};
      this.successMessage = "";
      this.apierror = "";
      const TaxCalculationData = {
        state: this.state,
        category: this.category,
        quantity: this.quantity || 0,
        sale_price: this.sale_price || 0,
        country: this.country,
        lsu_weight: this.lsu_weight || 0,
        lsu_volume: this.lsu_volume || 0,
        lsu_factor: this.lsu_factor || 0,
        cost_price: this.cost_price || 0,
        title: this.title,
        distributor: this.distributor || "No",
        brand: this.brand || "N/A",
        contains_nicotine:
          this.contains_nicotine === "Yes"
            ? "Y"
            : this.contains_nicotine === "No"
            ? "N"
            : null,
      };

      try {
        const res = await AddTaxCalculation(TaxCalculationData);
        if (res.data.error) {
          this.apierror = res.data.error ;
            console.log("the error is ",this.apierror)
          this.successMessage = "";
          this.result = {};
        } else {
          this.successMessage = "Tax calculation successful!";
          this.apierror = "";
          this.result = res.data;
        }
      } catch (error) {
        this.apierror = error.response?.data?.error;
        /*       console.log("the errro is ", this.apierror);  */
        this.successMessage = "";
      } finally {
        this.loader = false;
      }
    },
  },
};
</script>

<style scoped>
h1 {
  background: linear-gradient(135deg, #0f2027, #203a43, #2c5364);
  color: white;
  max-width: 525px;
  text-align: center;
  position: relative;
}

.alert-danger {
  font-size: 16px;
  padding: 12px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.alert-danger i {
  font-size: 18px;
}

.container {
  max-width: 1100px;
}

form {
  background-color: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 70px;
}

.result-box {
  margin-top: 20px;
  background-color: #e9f7ef;
  border-left: 5px solid #28a745;
}

.result-value {
  word-break: break-word;
  white-space: normal;
  font-weight: 500;
  color: green;
}
@media (max-width: 768px) {
  .row {
    flex-direction: column;
  }
}

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.fancy-loader {
  width: 60px;
  height: 60px;
  border: 6px solid #e0e0e0;
  border-top: 6px solid #007bff;
  border-radius: 50%;
  animation: slow-spin 1.8s ease-in-out infinite;
  box-shadow: 0 0 10px rgba(0, 123, 255, 0.3);
}

@keyframes slow-spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
